import { Grid } from "@mui/material";
import { OdcGsdbForm } from "./OdcGsdbForm";
import { OdcDataForm } from "./OdcDataForm";
import { OdcGeoLocationForm } from "./OdcGeoLocationForm";
import { OdcTypeChangedProps } from "./OdcFormProps";
import { MdmFormProps } from "../../Forms/MdmFormProps";

export function OdcForm({ disabledFields, onOdcTypeChanged }: MdmFormProps & OdcTypeChangedProps) {
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={12}>
        <OdcGsdbForm disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={9}>
        <OdcDataForm disabledFields={disabledFields} onOdcTypeChanged={onOdcTypeChanged} />
      </Grid>
      <Grid item xs={3}>
        <OdcGeoLocationForm disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
}
